export default __webpack_public_path__ + "static/media/flag-germany.cc6dc5ee.svg";